import { useEffect, useState } from "react";
import { Button, Icon, Modal, Toast } from "../../components";
import ProgressBar from "../../components/ProgressBar";

const FixedAlert = ({ show, text, onClose, buttonText = true }) => {

  if (!show) {
    return <></>;
  }
  return (
    <div className="fixed-alert">
      <Icon id="icon-warning_fill" className="me-2" size="24" />
      <div className={`fixed-alert-body`}>
        <p>{text}</p>
        {buttonText && (
          <button onClick={onClose} type="button" className="btn">
            {typeof buttonText === "string" ? buttonText : "Alterar"}
          </button>
        )}
      </div>
    </div>
  );
};

const BillingModal = ({
  show,
  onClose,
  title,
  description,
  progress,
  renew,
  children,
}) => {
  return (
    <Modal.Alert
      onClose={onClose}
      show={show}
      icon="icon-warning"
      title={title}
      className="billing-modal"
      description={description}
    >
      {progress && (
        <div className="billing-modal-progress">
          <p>{progress}% de documentos utilizados</p>
          <ProgressBar value={progress} className="warning" />
          {renew && (
            <p className="billing-modal-progress-renew">
              Próxima renovação em {renew}
            </p>
          )}
        </div>
      )}
      {children}
    </Modal.Alert>
  );
};

const ResponsiveAlert = ({ text, show, onClose }) => {
  const [showAlert, setShowAlert] = useState(false);
  const [modalState, setModalState] = useState(false);

  useEffect(() => {
    if (!show) return;
    show && window.innerWidth > 768 ? setShowAlert(true) : setModalState(true);
  }, [show]);
  return (
    <>
      <Toast
        variant="success"
        show={showAlert}
        onClose={() => {
          setShowAlert(false);
          onClose();
        }}
        filled
      >
        {text}
      </Toast>
      <Modal.Alert
        onClose={() => {
          setModalState(false);
          onClose();
        }}
        className="alert-modal"
        show={modalState}
      >
        <div className="alert-modal-body">
          <Icon id="icon-success_fill" className="icon" style={{}} size={48} />
          <p>{text}</p>
          <Button
            variant="border"
            className="btn-block text-uppercase"
            onClick={() => {
              setModalState(false);
              onClose();
            }}
          >
            ok, Fechar
          </Button>
        </div>
      </Modal.Alert>
    </>
  );
};

export { FixedAlert, BillingModal, ResponsiveAlert };
